import { AdminLayout } from "@/components/Admin/AdminLayout"
import { Card } from "@/components/ui/card"

interface ResultDetail {
  id: number
  user_email?: string | null
  user_name?: string | null
  tipo_eneagrama?: number | null
  fim_at?: string | null
  created_at: string
  pontuacoes_eneagrama?: Record<string, number> | null
  inicio_at?: string | null
  advanced_inicio_at?: string | null
  advanced_fim_at?: string | null
  pontuacoes_avancadas?: Record<string, number> | null
  microperfil?: string | null
  user?: {
    id: number
    email: string
    name: string
  } | null
}

interface Props {
  result: ResultDetail
}

const formatDateTime = (value?: string | null) => {
  if (!value) return "-"
  const date = new Date(value)
  return new Intl.DateTimeFormat("pt-BR", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(date)
}

export default function TestResultsShow({ result }: Props) {
  return (
    <AdminLayout title={`Resultado #${result.id}`}>
      <Card className="p-4 md:p-6">
        <h2 className="text-lg font-semibold mb-3">Dados do resultado</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
          <div>
            <p className="text-muted-foreground">Usuário</p>
            <p className="font-medium">{result.user_name || "—"}</p>
            <p className="text-muted-foreground">{result.user_email || "—"}</p>
          </div>
          <div>
            <p className="text-muted-foreground">Tipo Eneagrama</p>
            <p className="font-medium">{result.tipo_eneagrama || "—"}</p>
          </div>
          <div>
            <p className="text-muted-foreground">Início</p>
            <p className="font-medium">{formatDateTime(result.inicio_at)}</p>
          </div>
          <div>
            <p className="text-muted-foreground">Conclusão</p>
            <p className="font-medium">{formatDateTime(result.fim_at)}</p>
          </div>
        </div>
      </Card>

      <Card className="p-4 md:p-6">
        <h2 className="text-lg font-semibold mb-3">Pontuações</h2>
        {result.pontuacoes_eneagrama ? (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 text-sm">
            {Object.entries(result.pontuacoes_eneagrama).map(([key, value]) => (
              <div key={key} className="bg-muted/50 rounded-md px-3 py-2">
                <span className="text-muted-foreground">Tipo {key}</span>
                <div className="text-lg font-semibold">{value}</div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-muted-foreground">Sem pontuações registradas.</p>
        )}
      </Card>

      <Card className="p-4 md:p-6">
        <h2 className="text-lg font-semibold mb-3">Teste Avançado</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm mb-4">
          <div>
            <p className="text-muted-foreground">Microperfil</p>
            <p className="font-medium">{result.microperfil || "—"}</p>
          </div>
          <div>
            <p className="text-muted-foreground">Início</p>
            <p className="font-medium">{formatDateTime(result.advanced_inicio_at)}</p>
          </div>
          <div>
            <p className="text-muted-foreground">Conclusão</p>
            <p className="font-medium">{formatDateTime(result.advanced_fim_at)}</p>
          </div>
        </div>
        {result.pontuacoes_avancadas ? (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 text-sm">
            {Object.entries(result.pontuacoes_avancadas).map(([key, value]) => (
              <div key={key} className="bg-muted/50 rounded-md px-3 py-2">
                <span className="text-muted-foreground">{key}</span>
                <div className="text-lg font-semibold">{value}</div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-muted-foreground">Sem pontuações avançadas registradas.</p>
        )}
      </Card>
    </AdminLayout>
  )
}
